import uuid from 'uuid';

const defaultState = {
  appInstanceId: uuid.v4(),
  isOffline: !!window.data,
  initialized: false,
};

const appReducer = (state = defaultState, action) => {
  switch (action.type) {
    case 'INIT':
      return {
        ...state,
        initialized: true,
      };
    case 'DEINIT':
      return {
        ...state,
        initialized: false,
      };
    default:
      return state;
  }
};

export default appReducer;
